export default __webpack_public_path__ + "static/title-fantasy-football-1c37844a8afda82286f82028ded356e6.svg";